import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { useStyles } from './styles'
import { formatDateTime, isHttpsUrl } from './utils'

// The coach's reply, as the golfer sees it. The coach side renders the same
// data with its own `request-response.js`; this one takes the golfer pages'
// card, player tile and button styles.
const RequestResponseCard = ({ request, title }) => {
  const classes = useStyles()
  const { response } = request

  if (!response) return null

  return (
    <section className={classes.card} aria-labelledby="request-response-title">
      <Box className={classes.cardHeader}>
        <Typography
          id="request-response-title"
          variant="h2"
          className={classes.cardTitleText}
        >
          {title}
        </Typography>
      </Box>
      <Box className={classes.cardBody}>
        {response.videoUrl ? (
          <Box className={classes.videoTile}>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              className={classes.video}
              src={response.videoUrl}
              poster={response.thumbnailUrl || undefined}
              controls
              playsInline
            />
          </Box>
        ) : null}
        {isHttpsUrl(response.onformUrl) ? (
          <Box className={classes.actionRow}>
            <Button
              variant="outlined"
              color="primary"
              component="a"
              href={response.onformUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open analysis in Onform
            </Button>
          </Box>
        ) : null}
        {response.notes ? (
          <Typography className={clsx(classes.notes, classes.responseNotes)}>
            {response.notes}
          </Typography>
        ) : null}
        {response.sharedAt ? (
          <Typography className={classes.responseShared}>
            Shared {formatDateTime(response.sharedAt)}
          </Typography>
        ) : null}
      </Box>
    </section>
  )
}

RequestResponseCard.propTypes = {
  title: PropTypes.string.isRequired,
  request: PropTypes.shape({
    response: PropTypes.shape({
      videoUrl: PropTypes.string,
      onformUrl: PropTypes.string,
      thumbnailUrl: PropTypes.string,
      notes: PropTypes.string,
      sharedAt: PropTypes.string,
    }),
  }).isRequired,
}

export default RequestResponseCard
